import Vue from 'vue'
import Vuex from 'vuex'

import Ui from './modules/ui'
import User from './modules/user'
import Cart from './modules/cart'
import Acupuncture from './modules/acupuncture'
import Drugs from './modules/drugs'
import ICD from './modules/icd'
import Appointment from './modules/appointment'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
		ui: Ui,
		user: User,
		cart: Cart,
		acupuncture: Acupuncture,
		drugs: Drugs,
		icd: ICD,
		appointment: Appointment
	}
})
